import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';

import { MoreInfoSliderProps } from '../types';
import { SchoolTagsSection } from '../SchoolTags/SchoolTagsSection';
import { ConnectSchoolTagDisplayAtLocations } from 'features/Connect/utils/connectEnums';
export const SchoolDetailsSection: React.FC<MoreInfoSliderProps> = ({ school }) => {
  const schoolAddressString = (schoolAddressObject) => {
    const streetAddress = schoolAddressObject?.line_1;
    const city = schoolAddressObject?.city;
    const state = schoolAddressObject?.state;
    const zip = schoolAddressObject?.zipcode;
    return `${streetAddress}. ${city}, ${state} ${zip}`;
  };
  return (
    <MoreInfoSchoolDetailsContainer>
      {school && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Label>Location</Label>
          </Grid>
          <Grid item xs={12}>
            <Address>{schoolAddressString(school?.physical_address)}</Address>
          </Grid>
          {school?.tags &&
            school?.tags.some((tag) =>
              tag?.display_at?.includes(ConnectSchoolTagDisplayAtLocations.SCHOOL_DETAIL_SECTION)
            ) && (
              <>
                <Grid item xs={12}>
                  <Label>Details</Label>
                </Grid>
                <Grid item>
                  <SchoolTagsSection
                    school={school}
                    display_at={ConnectSchoolTagDisplayAtLocations.SCHOOL_DETAIL_SECTION}
                  />
                </Grid>
              </>
            )}
        </Grid>
      )}
    </MoreInfoSchoolDetailsContainer>
  );
};

const MoreInfoSchoolDetailsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  border: `solid 1px ${theme.palette.gray.light}`,
  borderRadius: theme.shape.borderRadius * 0.5,
  padding: theme.spacing(2),
  backgroundColor: '#F9FAFB',
  margin: theme.spacing(1, 0),
}));

const Label = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.gray.dark,
}));

const Address = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.h3.fontSize,
  color: theme.palette.gray.dark,
}));
